var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lineChart",staticStyle:{"flex":"1"},style:({ width: _vm.width, height: _vm.height }),attrs:{"id":"spec-pie"}})
}
var staticRenderFns = []

export { render, staticRenderFns }